import React from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tag } from 'primereact/tag';
import { TaskAssignmentResult } from 'types/interfaces/TaskAssignmentResult';

import { employeeAssignmentResultColumnWidths as W } from './columnWidths';
import { getAssignmentErrorMessage } from './lib/assignmentErrors';

interface AutoEmployeeAssignmentTableProps {
  tasksToAssignResponse: TaskAssignmentResult[];
}

const hasErrors = (task: TaskAssignmentResult) =>
  Array.isArray(task.errors) && task.errors.length > 0;

const isSuccessfulEmployeeAssignment = (task: TaskAssignmentResult) =>
  !hasErrors(task);

const AutoEmployeeAssignmentTable: React.FC<
  AutoEmployeeAssignmentTableProps
> = ({ tasksToAssignResponse }) => {
  const statusBody = (rowData: TaskAssignmentResult) => {
    const isSuccess = isSuccessfulEmployeeAssignment(rowData);
    return (
      <Tag
        value={isSuccess ? 'Распределено' : 'Ошибка'}
        severity={isSuccess ? 'success' : 'danger'}
      />
    );
  };

  const employeesBody = (rowData: TaskAssignmentResult) => {
    if (!rowData.employees?.length) return null;
    return (
      <div>
        {rowData.employees
          .map((e) => e.fullName ?? e.label ?? '')
          .filter(Boolean)
          .join(', ')}
      </div>
    );
  };

  const noteBody = (rowData: TaskAssignmentResult) => {
    if (!hasErrors(rowData)) return null;
    return (
      <div>
        {rowData.errors?.map((error, index) => (
          <div key={index}>{getAssignmentErrorMessage(error)}</div>
        ))}
      </div>
    );
  };

  return (
    <DataTable
      size="small"
      value={tasksToAssignResponse}
      scrollable
      emptyMessage="Нет данных"
    >
      <Column
        field="taskId"
        header="Номер наряда"
        style={{ width: W.taskId }}
      />
      <Column
        field="taskType"
        header="Тип наряда"
        body={(r: TaskAssignmentResult) => r.taskType?.label || ''}
        style={{ width: W.taskType }}
      />
      <Column field="name" header="Название наряда" style={{ width: W.name }} />
      <Column
        header="Статус распределения"
        body={statusBody}
        style={{ width: W.status }}
      />
      <Column
        header="Сотрудники"
        body={employeesBody}
        style={{ width: W.employees }}
      />
      <Column header="Примечание" body={noteBody} style={{ width: W.note }} />
    </DataTable>
  );
};

export default AutoEmployeeAssignmentTable;
